import React from 'react';
import { renderAsteriskBold } from '../utils/emphasis';
import { sanitizeHtml } from '../utils/html';

export type TopSupportingEvidenceItem = {
  id: string;
  title: string;
  content: string;
};

export interface TopSupportingEvidenceProps {
  items?: TopSupportingEvidenceItem[];
  onViewAllSourcesClick?: () => void;
}

export default function TopSupportingEvidence({ items, onViewAllSourcesClick }: TopSupportingEvidenceProps) {
  if (!items || items.length === 0) return null;

  const isProbablyHtml = (value: string) => /<\s*[a-z][\s\S]*>/i.test(value);

  const renderContent = (value: string) => {
    if (isProbablyHtml(value)) {
      return (
        <div
          className="ql-snow rpe-display"
          dangerouslySetInnerHTML={{ __html: `<div class="ql-editor">${sanitizeHtml(value)}</div>` }}
        />
      );
    }
    return renderAsteriskBold(value);
  };

  const isSingle = items.length === 1;
  return (
    <div className="mb-[80x] mt-[44px] w-full bg-white p-[0px] pb-[80x] relative">
      <div className="flex items-start justify-between">
        <p
          className="font-['Roboto_Slab',serif] text-[20px] font-bold leading-[36px] tracking-[0.75px] text-[#132543]"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          Top Supporting Evidence
        </p>
        {onViewAllSourcesClick && (
          <button
            type="button"
            className="font-['Open_Sans',sans-serif] text-[14px] font-semibold leading-[normal] text-[#25ADE3]"
            style={{ fontVariationSettings: "'wdth' 100" }}
            onClick={onViewAllSourcesClick}
            aria-label="View all sources"
          >
            View All Sources
          </button>
        )}
      </div>

      <div className={`mt-[16px] grid grid-cols-1 gap-[18px]${isSingle ? '' : ' md:grid-cols-2'}`}>
        {items.map((item) => (
          <div
            key={item.id}
            className="rounded-[20px] bg-[#DCEDF7] px-[18px] py-[16px]"
          >
            <p
              className="font-['Roboto_Slab',serif] text-[16px] font-bold leading-[28px] tracking-[0.5px] text-[#132543]"
              style={{ fontVariationSettings: "'wdth' 100" }}
            >
              {renderContent(item.title)}
            </p>
            <div
              className="mt-[10px] font-['Open_Sans',sans-serif] text-[14px] font-normal leading-[normal] text-[#31394C]"
              style={{ fontVariationSettings: "'wdth' 100" }}
            >
              {renderContent(item.content)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
